// extracted by mini-css-extract-plugin
export default {"icon":"ContactMe_icon__Q1ord","contactInfo":"ContactMe_contactInfo__lf6er","contactDetails":"ContactMe_contactDetails__euzfR"};